export default __webpack_public_path__ + "static/media/poll-24px-logo.e85caf36.svg";